module.exports = __webpack_public_path__ + "assets/media/search-black.f6f452b7.svg";